<template>
	<v-card tile elevation="0" style="height: 100%; overflow-y: hidden">
		<v-card-title class="text-left card-header fixed-card-title2">
			<v-row no-gutters>
				<v-col cols="6">
					<v-toolbar-title>{{ $t('add-care-plan-header') }}</v-toolbar-title>
				</v-col>
				<v-spacer />
				<v-icon color="white" @click="closeDrawer">mdi-close</v-icon>
			</v-row>
		</v-card-title>
		<v-card-text v-if="currentRecord" class="pa-4 pb-0 overflow-y-auto" style="height: calc(100vh - 221px)">
			<v-row dense class="ma-0">
				<v-col cols="12">
					<v-select
						:label="$t('status')"
						v-model="selectedStatus"
						:items="carePlanStatusTemplate"
						item-text="status"
						outlined
						hide-details
						:menu-props="{ maxHeight: 199, offsetY: true }">
						<template v-slot:item="{ item }">
							<v-tooltip left>
								<template v-slot:activator="{ on, attrs }">
									<span v-bind="attrs" v-on="on" style="width: 100%"> {{ item.status }}</span>
								</template>
								{{ item.description }}
							</v-tooltip>
						</template>
					</v-select>
				</v-col>
			</v-row>
			<v-row dense class="ma-0">
				<v-col cols="12">
					<v-select
						:label="$t('type')"
						v-model="selectedType"
						:items="carePlanTypeTemplate"
						item-text="typeName"
						outlined
						hide-details
						:menu-props="{ maxHeight: 199, offsetY: true }">
						<template v-slot:item="{ item }">
							<v-tooltip left>
								<template v-slot:activator="{ on, attrs }">
									<span v-bind="attrs" v-on="on" style="width: 100%">
										{{ item.typeName }}
									</span>
								</template>
								{{ item.description }}
							</v-tooltip>
						</template>
					</v-select>
				</v-col>
			</v-row>
			<v-row dense class="ma-0">
				<v-col cols="12">
					<v-textarea v-model="description" :label="$t('description')" outlined hide-details rows="12" />
				</v-col>
			</v-row>
		</v-card-text>
		<v-card-text
			v-else
			class="pa-4 overflow-y-auto text-center d-flex flex-column justify-center overflow-x-hidden"
			style="height: calc(100vh - 62px)">
			<v-icon color="grey" size="50" class="mb-3"> mdi-alert-circle-outline </v-icon>
			<p class="font-responsive-lg lightgrey">
				{{ $t('select-a-record') }}
			</p>
		</v-card-text>
		<v-container v-if="currentRecord" class="px-4">
			<v-row dense class="ma-0">
				<v-col cols="12">
					<InputTimeFormatter
						:inputValue="timeSpent"
						@update:inputValue="(val) => (timeSpent = val)"
						:inputLabel="$t('time-spent')"
						:dense="false" />
				</v-col>
			</v-row>
			<v-row dense class="ma-0">
				<v-col cols="6" order="1">
					<v-btn @click="closeDrawer()" color="secondary" style="color: black" block>
						{{ $t('cancel') }}
					</v-btn>
				</v-col>
				<v-tooltip top v-if="!addButtonEnabled">
					<template v-slot:activator="{ on, attrs }">
						<v-col cols="6" v-bind="attrs" v-on="on" order="2">
							<v-btn disabled block>{{ $t('add') }}</v-btn>
						</v-col>
					</template>
					<span>{{ $t('fill-all-fields-warning') }}</span>
				</v-tooltip>
				<v-col cols="6" v-else order="2">
					<v-btn @click="addCarePlan()" color="dark_purple" style="color: white" block>
						{{ $t('add') }}
					</v-btn>
				</v-col>
			</v-row>
		</v-container>
	</v-card>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import InputTimeFormatter from '../Client/components/InputTimeFormatter.vue';

export default {
	name: 'CCMCarePlanAdd',
	data () {
		return {
			description: '',
			selectedStatus: null,
			selectedType: null,
			timeSpent: 0,
			carePlanStatusTemplate: null,
			carePlanTypeTemplate: null,
		};
	},
	computed: {
		...mapState({
			currentRecord: (state) => state.ccmRecords.ccmRecord,
			userData: (state) => state.authentication.userData,
		}),
		addButtonEnabled () {
			return (
				this.description.trim() && this.selectedStatus && this.selectedType && this.timeSpent && this.timeSpent <= 7200
			);
		},
	},
	methods: {
		...mapActions({
			addCCMCarePlan: 'ccmCarePlans/addCCMCarePlan',
			getCCMCarePlans: 'ccmCarePlans/getCCMCarePlansByCCMRecordId',
			getAllCarePlanStatuses: 'ccmRecords/getAllCarePlanStatuses',
			getAllCarePlanTypes: 'ccmRecords/getAllCarePlanTypes',
			storeCCMRecordsByPatientId: 'ccmRecords/storeMinimalCCMRecordsByPatientId',
		}),
		async addCarePlan () {
			const request = {
				ccmRecordId: this.currentRecord.id,
				patientId: this.currentRecord.patientId,
				hospitalId: this.currentRecord.hospitalId,
				carePlanStatus: this.selectedStatus,
				date: new Date().toISOString(),
				type: this.selectedType,
				description: this.description,
				timeSpentSeconds: parseInt(this.timeSpent),
				staffId: this.userData.id,
				performedBy: `${this.userData.firstName} ${this.userData.lastName}`,
				performedByRole: this.userData.roleData.roleName,
				additionalData: '',
			};
			await this.addCCMCarePlan(request);
			await this.storeCCMRecordsByPatientId(this.currentRecord.patientId);
			this.closeDrawer();
		},
		closeDrawer () {
			this.selectedStatus = null;
			this.selectedType = null;
			this.description = '';
			this.timeSpent = 0;
			this.$store.commit('SET_DETAILS_DRAWER', false);
		},
	},
	async mounted () {
		if (!this.carePlanStatusTemplate) {
			const response = await this.getAllCarePlanStatuses();
			this.carePlanStatusTemplate = response.data;
		}
		if (!this.carePlanTypeTemplate) {
			const response = await this.getAllCarePlanTypes();
			this.carePlanTypeTemplate = response.data;
		}
	},
	components: { InputTimeFormatter },
};
</script>
